(() => {
  const banner = document.querySelector('[data-cookie-consent]');
  if (!banner) return;

  const acceptButton = banner.querySelector('[data-cookie-accept]');
  const declineButton = banner.querySelector('[data-cookie-decline]');
  const storageKey = 'yourshonen_cookie_consent_v1';
  let privacyApi = null;
  let initialized = false;

  const readStoredChoice = () => {
    try {
      const storedChoice = window.localStorage.getItem(storageKey);
      return storedChoice === 'accepted' || storedChoice === 'declined' ? storedChoice : null;
    } catch (error) {
      return null;
    }
  };

  const storeChoice = (choice) => {
    try {
      window.localStorage.setItem(storageKey, choice);
    } catch (error) {
      // Shopify's Customer Privacy API remains the primary persistent record.
    }
  };

  const hasShopifyChoice = (api) => {
    if (!api || typeof api.currentVisitorConsent !== 'function') return false;

    try {
      const consent = api.currentVisitorConsent();
      return ['analytics', 'marketing', 'preferences'].every((purpose) =>
        consent?.[purpose] === 'yes' || consent?.[purpose] === 'no'
      );
    } catch (error) {
      return false;
    }
  };

  const showBanner = () => {
    banner.hidden = false;
  };

  const hideBanner = () => {
    banner.hidden = true;
  };

  const initialize = (api = null) => {
    if (initialized) return;
    initialized = true;
    privacyApi = api;

    if (readStoredChoice() || hasShopifyChoice(privacyApi)) {
      hideBanner();
      return;
    }

    showBanner();
  };

  const setButtonsDisabled = (disabled) => {
    acceptButton.disabled = disabled;
    declineButton.disabled = disabled;
  };

  const saveConsent = (accepted) => {
    setButtonsDisabled(true);

    let completed = false;
    const finish = () => {
      if (completed) return;
      completed = true;
      storeChoice(accepted ? 'accepted' : 'declined');
      hideBanner();
      setButtonsDisabled(false);

      document.dispatchEvent(
        new CustomEvent('yourshonen:cookie-consent', {
          detail: { accepted },
        })
      );
    };

    if (privacyApi && typeof privacyApi.setTrackingConsent === 'function') {
      privacyApi.setTrackingConsent(
        {
          analytics: accepted,
          marketing: accepted,
          preferences: accepted,
        },
        finish
      );

      window.setTimeout(finish, 2000);
      return;
    }

    finish();
  };

  acceptButton.addEventListener('click', () => saveConsent(true));
  declineButton.addEventListener('click', () => saveConsent(false));

  if (readStoredChoice()) {
    initialize();
  } else if (window.Shopify?.customerPrivacy) {
    initialize(window.Shopify.customerPrivacy);
  } else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => initialize(error ? null : window.Shopify.customerPrivacy)
    );

    window.setTimeout(() => initialize(window.Shopify?.customerPrivacy || null), 2000);
  } else {
    initialize();
  }
})();
